import { connect } from "react-redux";
import { getSpSetting } from "store/selector/sp.selector";
import EmployeeFeedback from "./EmployeeFeedback";

const mapStateToProps = (state) => ({
  settings: getSpSetting(state),
});

export default connect(mapStateToProps)(EmployeeFeedback);
